import { render } from "./EventRegistrantsList.vue?vue&type=template&id=d0f6a9cc&scoped=true"
import script from "./EventRegistrantsList.vue?vue&type=script&lang=js"
export * from "./EventRegistrantsList.vue?vue&type=script&lang=js"

import "./EventRegistrantsList.vue?vue&type=style&index=0&id=d0f6a9cc&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0f6a9cc"]])

export default __exports__